import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Text } from '@rsos/components/capstone/base';
import { ESRI, GOOGLE } from '@rsos/constants/mapProviders';

const BasemapTooltip = () => {
  const mapProvider = useSelector(state => state.sinatra.ui.mapProvider);

  const isBasemapVisible = useSelector(
    state => state.sinatra.ui.isBasemapVisible,
  );

  const tooltipText = useMemo(() => {
    if (mapProvider === GOOGLE) {
      return 'Available with Esri Maps';
    } else if (mapProvider === ESRI && !isBasemapVisible) {
      return 'Unable to turn off GIS without a basemap selected';
    } else {
      return '';
    }
  }, [isBasemapVisible, mapProvider]);

  return (
    <Box
      backgroundColor="primaryText"
      data-name="basemap-tooltip"
      borderRadius="5px"
      padding="10px"
    >
      <Text
        color="background"
        data-name="basemap-tooltip-text"
        noWrap
        size="small"
      >
        {tooltipText}
      </Text>
    </Box>
  );
};

export default BasemapTooltip;
